import { beehiivServersideApi } from './beehiiv.serverside';
import { BeehiivCustomField, BeehiivPublicationIds } from './constants';
import { SubscribeToPublicationInputs } from './models';

const subscribeToNewsletterRequest = async (
    email: string,
    subscribeTo: BeehiivPublicationIds[],
    source: string = 'Website',
    sourcePath: string = '',
    campaign: string = '',
    medium: string = 'organic',
    customFields: BeehiivCustomField[] = [],
    forceEnableDoubleOptIn?: boolean,
) => {
    const promises = subscribeTo.map(async publicationId =>
        subscribeToPublication(
            email,
            publicationId,
            source,
            sourcePath,
            campaign,
            medium,
            customFields,
            forceEnableDoubleOptIn,
        ),
    );

    return Promise.all(promises);
};

const subscribeToPublication = async (
    email: string,
    publicationId: string,
    source: string = 'Website',
    sourcePath: string = '',
    campaign: string = '',
    medium: string = 'organic',
    customFields?: BeehiivCustomField[],
    forceEnableDoubleOptIn?: boolean,
): Promise<any> => {
    let userSubscription;

    try {
        const { data: subscription } = await beehiivServersideApi.get.subscriptionByEmail({
            email,
            publicationId: publicationId as BeehiivPublicationIds,
            expand: ['custom_fields'],
        });

        userSubscription = subscription;
    } catch (err) {
        console.error('Error fetching beehiiv user subscription:', err);
        userSubscription = null;
    }

    try {
        const options: SubscribeToPublicationInputs = {
            email,
            reactivate_existing: userSubscription?.status === 'inactive',
            send_welcome_email: true,
            source,
            campaign,
            medium,
            referring_site: `blockworks.co${sourcePath}`,
            custom_fields: customFields,
            publication: publicationId as BeehiivPublicationIds,
            sourcePath,
        };

        if (forceEnableDoubleOptIn) {
            options.double_opt_override = 'on';
        }

        return await beehiivServersideApi.post.subscribeToPublication(options);
    } catch (err) {
        console.error(`Error subscribing ${email} to ${publicationId}: Beehiiv`);
        throw new Error(`Error subscribing. Please try again later.`);
    }
};

export { subscribeToNewsletterRequest, subscribeToPublication };
